import React, { useContext, useRef, useState } from 'react'

import { Button, Card, Divider, Typography } from 'antd'
import { StarFilled } from '@ant-design/icons'

import { CreateAudienceDataContext } from '../../../helpers/Context';

export default function MarketingAudienceTopCard({ topAudienceData, onClick }) {
   
   const [clicked, setClicked] = useState(false);
   
   const {diAppRef} = useContext(CreateAudienceDataContext)

   // ------------- gestisco l'animazione della stella -------------
   const animateStar = () => {
      setClicked(true);
      setTimeout(() => {
         setClicked(false)
      }, 1000);
   }
   // ------------- gestisco l'animazione della stella -------------

  return (
     <div className='p-10'>
      <Card
         bordered={false}
         className='m-15 di-filters-preset-card overflow-hidden radius-3 bg-dark-02'
         actions={[
            <Button
               ref={diAppRef.refTopAudiencesButton}
               onClick={() => {
                  onClick(topAudienceData);
                  animateStar()
               }}
               type='primary'
               icon={<div className='relative'><StarFilled className='absolute'/><StarFilled className={`di-filter-preset-star ${clicked ? "clicked" : ""}`} /></div>}
            > Attiva Filtri
            </Button>,
         ]}
      >
         <Typography className='fs-16 bold'>{topAudienceData.title}</Typography>
         <Divider className='mt-10 mb-10'></Divider>
         <Typography className='fs-16 h-100'>{topAudienceData.description}</Typography>
      </Card>
   </div>
  )
}
